module.exports = __webpack_public_path__ + "static/assets/1157205071ed65c811dbb73fb4a01305.ttf";